import {defineStore} from "pinia";

export const useContratStore = defineStore('contrat', {
    state: () => ({
        contrat: {},
        contrats: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setContrat(contrat) {
            this.contrat = contrat
        },
        setContrats(contrats) {
            this.contrats = contrats
        },
        addContrat(contrat) {
            this.contrats.unshift(contrat)
        },
        updateContrat(contrat) {
            let index = this.contrats.findIndex(cl => cl.id === contrat.id)
            this.contrats.splice(index, 1, contrat)
        },
        deleteContrat(contrat) {
            let index = this.contrats.findIndex(cl => cl.id === contrat.id)
            this.contrats.splice(index, 1)
        },
        removeArchiveByWorkerId(workerId) {
            let index = this.contrats.findIndex(cl => cl.workerId === workerId);
            this.contrats.splice(index, 1);
        },
    },
});